export const ESERVICES_PRIVACY_POLICY_TYPE = "eservices_privacy_policy";

export const IMAGES = {
  LOGO: "/static/images/logo.svg",
  USER_ICON: "/static/images/user-icon.svg",
  PASSWORD_ICON: "/static/images/password-key.svg",
  SINGPASS: "/static/images/singpass_logo.svg",
  SINGPASS_GRAY: "/static/images/singpass_logo_gray.svg",
  PAWN_TICKET: "/static/images/pawn_ticket.svg",
  INSTALMENT_ICON: "/static/images/instalment.svg",
  RIGHT_ARROW_ICON: "/static/images/right_outline_arrow.svg",
  SUCCESS_ICON: "/static/images/success_icon.svg",
  ERROR_ICON: "/static/images/error_icon.svg",
  LOGIN_RIGHT_ARROW: "/static/images/login-right-arrow.svg",
  DASHBOARD_ICON: "/static/images/active_dashboard.svg",
  DASHBOARD_INACTIVE_ICON: "/static/images/deactive_home.svg",
  DASHBOARD_HOVER_ICON: "/static/images/hover_home.svg",
  PROFILE_ICON: "/static/images/profile_icon.svg",
  BACK_BUTTON: "/static/images/back_button.svg",
  UP_ARROW: "/static/images/up_arrow.svg",
  DOWN_ARROW: "/static/images/down_arrow.svg",
  BRANCH_ICON: "/static/images/branch_icon.svg",
  CALENDAR_ICON: "/static/images/calendar_icon.svg",
  TICKET_ICON: "/static/images/ticket_icon.svg",
  ARTICLE_ICON: "/static/images/article_icon.svg",
  DASHBOARD_1st_card: "/static/images/dashboard_1st_card.svg",
  DASHBOARD_2nd_card: "/static/images/dashboard_2nd_card.svg",
  DASHBOARD_3rd_card: "/static/images/dashboard_3rd_card.svg",
  DASHBOARD_4th_card: "/static/images/dashboard_4th_card.svg",
  OFFER_BANNER: "/static/images/offer_banner.svg",
  DUE_ICON: "/static/images/due_icon.svg",
  PAYABLE_ICON: "/static/images/payable.svg",
  ACTIVE_TICKET_ICON: "/static/images/active_ticket_icon.svg",
  FILTER_ACTIVE_ICON: "/static/images/active_filter_icon.svg",
  FILTER_DEFAULT_ICON: "/static/images/default_filter_icon.svg",
  RELOAD_ICON: "/static/images/reload.svg",
  TOP_ARROW: "/static/images/top_arrow.svg",
  NOTIFICATION_ICON: "/static/images/notification_icon.svg",
  RED_INFO_ICON: "/static/images/red_info_icon.svg",
  DOWNLOAD_ICON: "/static/images/downloan_icon.svg",
  PROFILE_AVATAR: "/static/images/profile_avatar.svg",
  EDIT_ICON_BUTTON: "/static/images/edit_icon_button.svg",
  PLEDGE_ICON: "/static/images/active_Pledge.svg",
  ECOMMERCE_ICON: "/static/images/active_e_commerce.svg",
  TRANSACTIONS_ICON: "/static/images/active_transaction.svg",
  SETTINGS_ICON: "/static/images/active_settings.svg",
  NOTIFICATIONS_ICON: "/static/images/active_notification.svg",
  PLEDGE_HOVER_ICON: "/static/images/hover_pledge.svg",
  ECOMMERCE_HOVER_ICON: "/static/images/hover_e_commerce.svg",
  TRANSACTIONS_HOVER_ICON: "/static/images/hover_transaction.svg",
  SETTINGS_HOVER_ICON: "/static/images/hover_settings.svg",
  NOTIFICATIONS_HOVER_ICON: "/static/images/hover_notification.svg",
  LOGOUT_HOVER_ICON: "/static/images/hover_logout.svg",
  PLEDGE_INACTIVE_ICON: "/static/images/deactive_pledge.svg",
  ECOMMERCE_INACTIVE_ICON: "/static/images/deactive_e_commerce.svg",
  TRANSACTIONS_INACTIVE_ICON: "/static/images/deactive_transaction.svg",
  SETTINGS_INACTIVE_ICON: "/static/images/deactive_settings.svg",
  NOTIFICATIONS_INACTIVE_ICON: "/static/images/deactive_notification.svg",
  LOGOUT_INACTIVE_ICON: "/static/images/deactive_logout.svg",
  EMAIL_NOT_FOUND: "/static/images/email_not_found.svg",
  EMAIL_FIRST_LOGIN: "/static/images/email_first_login.svg",
  SINGPASS_LOGO: "/static/images/singpass_logo.svg",
  FINGER_SCAN: "/static/images/finger_scan.svg",
  BARCODE_IMAGE: "/static/images/BarCode.svg",
  IMAGE_404: "/static/images/404.svg",
  TOP_CORNER_404: "/static/images/topCorner404.svg",
  BOTTOM_CORNER_404: "/static/images/bottomCorner.svg",
  BASIC_INFO_ICON: "/static/images/basic_info.svg",
  WARNING_ICON_BRANCH: "/static/images/warning_icon_branch.svg",
  SINGPASS_LOGO_WHITE: "/static/images/singpass_logo_white.svg",
  DANGER_INFO_ICON: "/static/images/danger_icon.svg",
  APPROVAL_DANGER_ICON: "/static/images/approval_danger_icon.svg",
  DOIT_NOW_LOGO: "/static/images/doit_now_logo.svg",
  DUIT_NOW_ICON: "/static/images/duit_now_logo_icon.svg",
};

export const ROUTES_URL = {
  RESET_PASSWORD: "/reset-password",
  LOGIN: "/login",
  FORGOT_PASSWORD: "/forgot-password",
  DASHBOARD: "/dashboard",
  PLEDGE: "/pledge",
  PLEDGE_PAYMENT: "/pledge/:id",
  TRANSACTIONS: "/transactions",
  SETTINGS: "/settings",
  NOTIFICATIONS: "/notifications",
  LOGOUT: "/logout",
  PRIVACY_POLICY: "/privacypolicy",
  TERMS: "/terms",
  SINGPASS_SUCCESS: "/singpass-success",
  CUSTOMER_CONCENT: "/customer-consent",
  DUE_DILIGENCE: "/due-diligence",
  VIEW_PLEDGE_TICKET: "/view-pledge-ticket",
  PLEDGE_CONSENT_APPROVAL: "/pledge-consent-approval",
  APP_CUSTOMER_CONSENT: "/app-customer-consent",
  APP_CUSTOMER_CONSENT_APPROVAL: "/app-customer-consent-approval",
};

export const API_ROUTES = {
  login: "/customers/login",
  verifyOtp: "customers/customer-verify-otp",
  resendLoginOtp: "customers/customer-resend-otp",
  singpassValidate: "/singpass-auth/login-lite",
  loginOtpVerify: "/customers/otp/login/verify",
  loginOtpRetry: "/customers/otp/retry",
  forgotPassword: "/customers/forgot/password",
  resetPassword: "/customers/reset/password",
  changePassword: "/customers/change/password",
  otpVerify: "/customers/verify/otp",
  otpRetry: "/customers/generate/otp",
  customerDashboard: "/customers/dashboard/pledge",
  customers: "/customers",
  customerData: "/customers/details/all",
  customersVerifyEmail: "/customers/verify-email",
  acceptTermsConditions: "/customers/accept/tnc",
  forgotVerifyOTP: "/customers/verify-otp",
  resetPasswordNew: "/customers/reset-password",
  show_alert: "/alerts/show",
  PLEDGE: "/pledge/customer/pledges",
  PLEDGE_TRANSACTIONS: "/pledge/actions/transactions",
  PLEDGE_TICKET_PREVIEW: (pledgeId: string): string => `/pawn-tickets/${pledgeId}/preview`,
  PLEDGE_BULK_TICKET_PREVIEW: "/pawn-tickets/bulk/preview",
  PLEDGE_BULK_TICKET_PREVIEW_V1: "/pawn-tickets/bulk/preview/html",
  PLEDGES_PROMOTIONS_BY_IDS: "pledge/applied-promotions/get-by-pledge-ids",
  FILE_UPLOAD: "/tenant/upload",
  PROMOTIONS: "/promotions",
  PROVIDE_CUSTOMER_CONSENT: "/pledge-customer-consent/provide-consent",
  TENANT_MASTER_DATA: "/tenant-master-data/reference",
  TENANT_MASTER_PLEDGE_DATA: "/tenant-master-data",
  TENANT_DOWNTIME: "/tenant-master-data/downtime",
  E_RENEWAL: "/pledge-renewal-management/e-renew",
  TERMS_AND_CONDITIONS: "/terms-and-conditions/all",
  GET_ALL_NOTIFICATION: "/notifications/customer",
  NOTIFICATION_READ_ALL: "/notifications/customer/read-all",
  GET_PROMOTION: "/promotions",
  PLEDGE_CONSENT_DETAILS: "/pledge-customer-consent/customer-consent-by-refresh-code/",
  PAWN_TICKET_PREVIEW: "/pawn-tickets/:id/preview",
  UPDATE_PLEDGE_CONSENT: "/pledge-customer-consent/update/",
  UPDATE_PLEDGE_CONSENT_METADATA: "/pledge-customer-consent/update-metadata/",
  PLEDGE_CONSENT_STATUS: "/pledge-customer-consent/customer-consent/status",
  APPLICABLE_VOUCHERS: "/checkout-voucher/applicable",
  PLEDGE_SIGN: "/signing-sign/pawn-ticket/initiate-sign-by-self",
  GET_PLEDGE_ID: "/pledge",
  OCCUPATION: "/occupation-management",
  GET_CDD_LIST: "/customer-due-diligence",
  CDD_BULK_CREATE: "/customer-due-diligence/create",
  MPGS_SESSION: "/pledge-renewal-management/e-renew/mpgs/session/v1",
  GENERATE_RENEW_PAYNOW_STATUS: "/pledge-renewal-management/e-renew/dbs-max/paynow/qr/v1",
  RENEW_PAYMENT_STATUS: "/pledge-renewal-management/e-renew/dbs-max/paynow/qr/status",
  INITIATE_PAYNET_PAYMENT: "/pledge-renewal-management/e-renew/uob/paynet/payment/initiate/v1",
  GET_PAYMENT_STATUS: "/pledge-renewal-management/e-renew/uob/paynet/status",
  REPORT_PAYNET_SELECTED_BANK: "/pledge-renewal-management/e-renew/uob/paynet/bank-selected",
  ERENEW_CREATE_PLEDGE: "/pledge-renewal-management/e-renew/uob/paynet/new-pledge/create",
  MY_CREATE_PLEDGE: "/pledge-renewal-management/e-renew/mpgs/new-pledge/create",
  GET_IDS_FROM_CONSULATE: "/pledge-renewal-management/mpgs/getrenewalids",
  GET_PAYMENT_AMOUNT: "/pledge-renewal-management/e-renew/payable/amount",
  QR_PAYMENT_PLEDGE: "/pledge-renewal-management/e-renew/dbs-max/paynow/qr/new-pledge/create",
  PLEDGE_CREATION_EINVOICE_SUBMIT: "/ocbc/pledge-creation/submit/document",
  PLEDGE_RENEWAL_EINVOICE_SUBMIT: "/ocbc/pledge-renewal/submit/document",
  PLEDGE_REDEMPTION_EINVOICE_SUBMIT: "/ocbc/pledge-redemption/submit/document",
  GET_IDTYPE_MASTER: "/id-type-master",
  PAYMENT_METHOD: "/branch-payment-methods",
  PAWN_TICKET_PREVIEW_HTML: "/pawn-tickets/:id/preview/html",
  LATEST_TERMS: "/terms-and-conditions/customer/latest",
  INITIATE_SINGPASS_SIGN: "/signing-sign/pawn-ticket/initiate-sign",
  BANNER_LIST: "/banners/customer",
  UPDATE_ACCESS_TOKEN: "/customers/refresh-token",
  GET_TENANT_METADATA: "/tenant/public/details",
  TENANT_FILES_STREAM: "/tenant/files/stream",
  CHECK_DOWNTIME: "/customers/check-downtime",
  SINGPASS_LOGIN_URL: "/singpass-auth/login",
};

export const Regex = {
  PHONE_NUMBER_REGEX: /^[0-9]*$/,
  OTP_REGEX: /^[0-9]?$/,
};

export const DATE_TIME_FORMAT_DISPLAY = "hh:mm A DD-MM-YYYY";
export const DATE_FORMAT_DISPLAY = "DD MMM YYYY";

export const DATE_FORMAT_START_OF_DAY = "YYYY-MM-DDT00:00:00.000Z";
export const DATE_FORMAT_END_OF_DAY = "YYYY-MM-DDT23:59:59.999Z";

export const OTP_LENGTH = 4;

export const AlertMessageMoveSpeed = 2.5;

export const DashbaordTableData = [
  {
    key: 1,
    pledge: "MB 0125 PWD00",
    date: "12 Jan 2025",
    expiry: "11 Jul 2025",
    interest: "S$ 3.40",
  },
  {
    key: 2,
    pledge: "BP 0125 QESP",
    date: "19 Jan 2025",
    expiry: "18 Jul 2025",
    interest: "S$ 5.40",
  },
  {
    key: 3,
    pledge: "ST 01/25 LMPHB",
    date: "19 Jan 2025",
    expiry: "18 Jul 2025",
    interest: "S$ 7.90",
  },
  {
    key: 4,
    pledge: "ST 01/25 LMPHB",
    date: "01 Feb 2025",
    expiry: "31 Jul 2025",
    interest: "S$ 6.10",
  },
];

export const PledgeData = [
  {
    key: "1",
    pledgeNumber: "MB 0125 BPWDQ",
    ticketDate: "12 Jan 2025",
    expiryDate: "11 Jul 2025",
    interest: "S$ 8.40",
    remarks: "",
  },
  {
    key: "2",
    pledgeNumber: "BP 0125 GESPF",
    ticketDate: "26 Aug 2025",
    expiryDate: "18 Feb 2026",
    interest: "S$ 3.40",
    remarks:
      "The pledge has already been renewed in the past 7 days. Renewal is not allowed at this time.",
  },
  {
    key: "3",
    pledgeNumber: "ST 0125 LMPHB",
    ticketDate: "19 Jan 2025",
    expiryDate: "18 Jul 2025",
    interest: "S$ 7.90",
    remarks: "",
  },
  {
    key: "4",
    pledgeNumber: "ST 0125 LMPHB",
    ticketDate: "01 Feb 2025",
    expiryDate: "31 Jul 2025",
    interest: "S$ 6.10",
    remarks: "",
  },
  {
    key: "5",
    pledgeNumber: "BP 0125 CVUTP",
    ticketDate: "03 Feb 2025",
    expiryDate: "12 Aug 2025",
    interest: "S$ 7.80",
    remarks: "",
  },
  {
    key: "6",
    pledgeNumber: "BP 0125 YGTYR",
    ticketDate: "20 Feb 2025",
    expiryDate: "16 Sep 2025",
    interest: "S$ 5.09",
    remarks: "",
  },
  {
    key: "7",
    pledgeNumber: "BP 0125 BRATY",
    ticketDate: "01 Mar 2025",
    expiryDate: "10 Oct 2025",
    interest: "S$ 3.10",
    remarks: "",
  },
  {
    key: "8",
    pledgeNumber: "BP 0125 ASRTY",
    ticketDate: "12 Nov 2025",
    expiryDate: "22 Nov 2025",
    interest: "S$ 6.10",
    remarks: "",
  },
  {
    key: "9",
    pledgeNumber: "BP 0125 LMJRO",
    ticketDate: "03 Mar 2025",
    expiryDate: "28 Nov 2025",
    interest: "S$ 7.22",
    remarks: "",
  },
];

export const PersonalData = {
  name: "Michael Grimes",
  idType: "NRIC",
  idNumber: "S1234567A",
  nationality: "Singapore",
  ethnicity: "Chinese",
  country: "Singapore",
  city: "Singapore",
  state: "Orchard",
  dob: "12-03-1996",
  sex: "Male",
  occupation: "Healthcare professional",
  email: "michaelgrimes@gmail.com",
  phoneNumber: "91234567",
  communicationMedium: "Email",
  preferred2FAMediumForOTP: "SMS",
  country_code: "SG",
  dial_code: "+65",
};

export const AddressData = {
  PermanentAddress: {
    AddressLine1: "10 Anson Road",
    AddressLine2: "#15-20 International Plaza",
    AddressLine3: "Singapore",
    PostalCode: "079903",
  },
  CorrespondingAddress: {
    AddressLine1: "10 Anson Road",
    AddressLine2: "#15-20 International Plaza",
    AddressLine3: "Singapore",
    PostalCode: "079903",
  },
};

export const JSON_DATA = {
  NATIONALITIES: "/static/nationalities.json",
  ETHNICITIES: "/static/ethnicities.json",
};

export const addressSections = [
  {
    title: "Permanent Address",
    prefix: "",
    fields: [
      { label: "Address Line 1", key: "address_line_1" },
      { label: "Address Line 2", key: "address_line_2" },
      { label: "Address Line 3", key: "address_line_3" },
      { label: "Postal Code", key: "postal_code" },
    ],
  },
  {
    title: "Corresponding Address",
    prefix: "corresponding_",
    fields: [
      { label: "Address Line 1", key: "address_line_1" },
      { label: "Address Line 2", key: "address_line_2" },
      { label: "Address Line 3", key: "address_line_3" },
      { label: "Postal Code", key: "postal_code" },
    ],
  },
];

export const CURRENCY_SYMBOLS: Record<string, { note: string; coin: string }> = {
  SGD: { note: "$", coin: "¢" },
  MYR: { note: "RM", coin: "sen" },
  S$: { note: "S$", coin: "¢" },
  RM: { note: "RM", coin: "sen" },
};

export const MYKAD_FIELDS = [
  "name",
  "id_type",
  "id_number",
  "nationality",
  "sex",
  "date_of_birth",
  "ethnicity",
  "address_line_1",
  "address_line_2",
  "address_line_3",
  "postal_code",
  "country",
  "state",
];

export const SINGPASS_FIELDS = [...MYKAD_FIELDS, "email", "mobile_number"];

export const SUPPORTED_COUNTRIES = {
  SG: "SG",
  MY: "MY",
};

export const isLocalhost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
export const OTP_RESEND_COOLDOWN = 60; // seconds
export const YYYY_MM_DD_DATE_FORMAT = "YYYY-MM-DD";
export const DD_MM_YYYY_SLASH_DATE_FORMAT = "DD/MM/YYYY";
